import { extendTheme } from "@chakra-ui/react";
import { theme as customTheme } from "_config";

export const theme = extendTheme(customTheme);
